/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} External_Apis_Remove_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "Calls to this API stop immediately. Its {count} spaces are deleted with their credentials, members, project links and tool settings." |
*
* @param {External_Apis_Remove_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const external_apis_remove_confirm_description = /** @type {((inputs: External_Apis_Remove_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<External_Apis_Remove_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Aufrufe dieser API werden sofort beendet. Ihre ${i?.count} Spaces werden mit ihren Zugangsdaten, Mitgliedern, Projektverknüpfungen und Werkzeug-Einstellungen gelöscht.`)
	return /** @type {LocalizedString} */ (`Calls to this API stop immediately. Its ${i?.count} spaces are deleted with their credentials, members, project links and tool settings.`)
});